(function () {
  'use strict';

  var UNIT_TO_METERS = {
    mm: 0.001,
    cm: 0.01,
    meters: 1,
    in: 0.0254,
    ft: 0.3048
  };

  var UNIT_TO_CPC_LABEL = {
    mm: 'mm',
    cm: 'cm',
    meters: 'meter',
    in: 'inches',
    ft: 'feet'
  };

  var validationMsg = 'Please enter width, height, and measurement units.';
  var validationPositiveMsg = 'Width and height must be greater than 0.';
  var MIN_AREA_SQM = 1;
  var POSITIVE_NUMBER_RE = /^(?:\d+\.?\d*|\.\d+)$/;

  function convertToMeters(value, unit) {
    var factor = UNIT_TO_METERS[unit];
    if (factor == null) return null;
    return value * factor;
  }

  function calculateSquareMeters(width, height, unit) {
    var widthM = convertToMeters(width, unit);
    var heightM = convertToMeters(height, unit);
    if (widthM == null || heightM == null) return null;
    return widthM * heightM;
  }

  /** Areas under 1 m² are still allowed, but billed at the 1 m² rate. */
  function getBillableSquareMeters(sqm) {
    if (sqm == null || isNaN(sqm)) return null;
    return Math.max(sqm, MIN_AREA_SQM);
  }

  /**
   * CPC rejects under-1 m². Push a clean 1×1 m equivalent so the price token is valid.
   * Real dims are stored separately as Ordered* line properties.
   */
  function getBillableCpcDimensions(width, height, unit) {
    var sqm = calculateSquareMeters(width, height, unit);
    if (sqm == null || sqm >= MIN_AREA_SQM) {
      return { width: width, height: height, unit: unit, sqm: sqm };
    }
    var factor = UNIT_TO_METERS[unit];
    if (factor == null) {
      return { width: width, height: height, unit: unit, sqm: sqm };
    }
    // 1 meter expressed in the selected unit (e.g. meters→1, cm→100, mm→1000).
    var oneMeterInUnit = 1 / factor;
    return {
      width: oneMeterInUnit,
      height: oneMeterInUnit,
      unit: unit,
      sqm: MIN_AREA_SQM
    };
  }

  function calculateTotalPrice(sqm, variantPriceCents) {
    if (sqm == null || variantPriceCents == null) return null;
    return Math.round(getBillableSquareMeters(sqm) * variantPriceCents);
  }

  function formatMoney(cents) {
    var moneyFormat = window.money_format || '${{amount}}';
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return (cents / 100).toFixed(2);
  }

  function validateDimensions(w, h, unit) {
    if (!w || !h || !unit) {
      return { valid: false, message: validationMsg, reason: 'incomplete' };
    }
    if (!POSITIVE_NUMBER_RE.test(w) || !POSITIVE_NUMBER_RE.test(h)) {
      return { valid: false, message: validationPositiveMsg, reason: 'format' };
    }
    var wn = parseFloat(w);
    var hn = parseFloat(h);
    if (!(wn > 0) || !(hn > 0)) {
      return { valid: false, message: validationPositiveMsg, reason: 'zero' };
    }
    var sqm = calculateSquareMeters(wn, hn, unit);
    if (sqm == null) {
      return { valid: false, message: validationMsg, reason: 'incomplete', width: wn, height: hn };
    }
    return { valid: true, message: '', reason: '', sqm: sqm, width: wn, height: hn };
  }

  function findDimensionRoot(form) {
    if (form) {
      var formDomId = form.getAttribute('id');
      if (formDomId) {
        var byForm = document.querySelector(
          '.product-dimension-fields[data-form-id="' + formDomId + '"]'
        );
        if (byForm) return byForm;
      }
      var nested = form.querySelector('.product-dimension-fields');
      if (nested) return nested;
    }
    return document.querySelector('.product-dimension-fields');
  }

  function rememberValidDimensions(dims) {
    window.__cspLastValidDimensions = {
      width: dims.width,
      height: dims.height,
      unit: dims.unit,
      unitLabel: UNIT_TO_CPC_LABEL[dims.unit] || dims.unit,
      sqm: dims.sqm
    };
  }

  /**
   * Validate theme width/height (> 0) and copy into CPC fields before add-to-cart.
   * Avoid PriceUpdation here — it can invalidate CPC's in-flight add token.
   */
  function prepareDimensionsForCart(form) {
    var root = findDimensionRoot(form);
    if (!root) return { ok: true, skipped: true };

    var inpW = root.querySelector('[data-dimension-width]');
    var inpH = root.querySelector('[data-dimension-height]');
    var selU = root.querySelector('[data-dimension-units]');
    var errEl = root.querySelector('[data-dimension-error]');

    var w = (inpW && String(inpW.value).trim()) || '';
    var h = (inpH && String(inpH.value).trim()) || '';
    var unit = (selU && selU.value) || '';
    var validation = validateDimensions(w, h, unit);

    if (!validation.valid) {
      if (errEl) {
        errEl.textContent = validation.message;
        errEl.classList.remove('hidden');
      }
      if (inpW && (!(parseFloat(w) > 0) || !w)) inpW.focus();
      else if (inpH && (!(parseFloat(h) > 0) || !h)) inpH.focus();
      else if (selU && !unit) selU.focus();
      return { ok: false, message: validation.message, reason: validation.reason };
    }

    rememberValidDimensions({
      width: validation.width,
      height: validation.height,
      unit: unit,
      sqm: validation.sqm
    });

  // CPC needs billable (>= 1 m²) W/H for a valid price token.
  // Real dims are submitted separately as Ordered* properties.
  var billable = getBillableCpcDimensions(validation.width, validation.height, unit);

    var calc = getCpcCalculator(form);
    if (calc) {
      var widthEl = cpcField(calc, 'Width');
      var heightEl = cpcField(calc, 'Height');
      var unitEl = cpcField(calc, 'Measurement Units');

      // Silent value sync only — do not trigger CPC recalculation on ATC click.
      if (widthEl) widthEl.value = String(billable.width);
      if (heightEl) heightEl.value = String(billable.height);
      if (unitEl && unit) {
        var label = UNIT_TO_CPC_LABEL[unit] || unit;
        var options = Array.prototype.slice.call(unitEl.options || []);
        var match = options.find(function (opt) {
          var optLabel = (opt.dataset && opt.dataset.label) || String(opt.textContent || '').trim();
          return String(optLabel).toLowerCase() === String(label).toLowerCase();
        });
        if (match) unitEl.value = match.value;
      }

      var widthNow = widthEl ? parseFloat(widthEl.value) : billable.width;
      var heightNow = heightEl ? parseFloat(heightEl.value) : billable.height;
      if (!(widthNow > 0) || !(heightNow > 0)) {
        var zeroMsg = validationPositiveMsg;
        if (errEl) {
          errEl.textContent = zeroMsg;
          errEl.classList.remove('hidden');
        }
        return { ok: false, message: zeroMsg, reason: 'cpc_zero' };
      }
    }

    if (errEl) {
      errEl.textContent = '';
      errEl.classList.add('hidden');
    }

    return {
      ok: true,
      width: validation.width,
      height: validation.height,
      unit: unit,
      sqm: validation.sqm
    };
  }

  window.cspPrepareDimensionsForCart = prepareDimensionsForCart;

  /**
   * True when customer area is under 1 m² AND CPC is not already billable-ready.
   * If CPC already has a valid 1 m² token from live recalculate, skip the ATC delay.
   */
  window.cspNeedsBillableCpcPrep = function (form) {
    var root = findDimensionRoot(form);
    if (!root) return false;
    var inpW = root.querySelector('[data-dimension-width]');
    var inpH = root.querySelector('[data-dimension-height]');
    var selU = root.querySelector('[data-dimension-units]');
    var w = (inpW && String(inpW.value).trim()) || '';
    var h = (inpH && String(inpH.value).trim()) || '';
    var unit = (selU && selU.value) || '';
    var validation = validateDimensions(w, h, unit);
    if (!(validation.valid && validation.sqm != null && validation.sqm < MIN_AREA_SQM)) {
      return false;
    }

    rememberValidDimensions({
      width: validation.width,
      height: validation.height,
      unit: unit,
      sqm: validation.sqm
    });

    var calc = getCpcCalculator(form);
    if (calc && isCpcBillableReady(calc, form)) {
      return false;
    }
    return true;
  };

  function isCpcBillableReady(calc, form) {
    if (!calc) return false;
    var results = readCpcResults(calc, form);
    if (!results) return false;
    var areaOk = results.sqm != null && results.sqm >= MIN_AREA_SQM * 0.99;
    var priceOk = results.totalCents != null && results.totalCents > 0;
    var tokenOk = !!results.tokenReady;
    return !!(areaOk && priceOk && tokenOk);
  }

  /**
   * Sync billable (>= 1 m²) dims into CPC and wait until token/price are valid.
   * Fast-path: resolve immediately when already ready (no re-sync / token invalidation).
   */
  window.cspPrepareBillableCpcSync = function (form) {
    return new Promise(function (resolve) {
      var root = findDimensionRoot(form);
      if (!root) {
        resolve(true);
        return;
      }

      var inpW = root.querySelector('[data-dimension-width]');
      var inpH = root.querySelector('[data-dimension-height]');
      var selU = root.querySelector('[data-dimension-units]');
      var errEl = root.querySelector('[data-dimension-error]');

      var w = (inpW && String(inpW.value).trim()) || '';
      var h = (inpH && String(inpH.value).trim()) || '';
      var unit = (selU && selU.value) || '';
      var validation = validateDimensions(w, h, unit);

      if (!validation.valid) {
        if (errEl) {
          errEl.textContent = validation.message;
          errEl.classList.remove('hidden');
        }
        resolve(false);
        return;
      }

      rememberValidDimensions({
        width: validation.width,
        height: validation.height,
        unit: unit,
        sqm: validation.sqm
      });

      var calc = getCpcCalculator(form);
      if (!calc) {
        resolve(true);
        return;
      }

      if (isCpcBillableReady(calc, form)) {
        if (errEl) {
          errEl.textContent = '';
          errEl.classList.add('hidden');
        }
        resolve(true);
        return;
      }

      var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
      var variantPriceCents = null;
      var variant = null;
      try {
        var sectionRoot = root.getAttribute('data-dimension-root');
        var fullJsonEl = sectionRoot
          ? document.getElementById('CustomVariantsFull-' + sectionRoot)
          : null;
        if (fullJsonEl && variantIdInput) {
          var variants = JSON.parse(fullJsonEl.textContent);
          var currentId = parseInt(variantIdInput.value, 10);
          variant = variants.find(function (v) {
            return v.id === currentId;
          });
          if (variant) variantPriceCents = variant.price;
        }
      } catch (e) { /* ignore */ }

      // Single CPC update (avoids 4–5 PriceUpdation calls that each reset the token).
      syncToCpc(
        calc,
        form,
        {
          width: validation.width,
          height: validation.height,
          unit: unit,
          quantity: 1,
          variantPriceCents: variantPriceCents,
          variant: variant
        },
        { singleUpdate: true }
      );

      function finishOk() {
        if (errEl) {
          errEl.textContent = '';
          errEl.classList.add('hidden');
        }
        resolve(true);
      }

      if (isCpcBillableReady(calc, form)) {
        finishOk();
        return;
      }

      var attempts = 0;
      var timer = setInterval(function () {
        attempts += 1;
        if (isCpcBillableReady(calc, form)) {
          clearInterval(timer);
          finishOk();
          return;
        }

        var results = readCpcResults(calc, form);
        var areaOk = results.sqm != null && results.sqm >= MIN_AREA_SQM * 0.99;
        var priceOk = results.totalCents != null && results.totalCents > 0;

        // ~1.6s max (40 × 40ms). Accept price+area if token lagging.
        if (attempts >= 40) {
          clearInterval(timer);
          if (priceOk && areaOk) {
            finishOk();
            return;
          }
          if (errEl) {
            errEl.textContent =
              'Pricing is still updating. Please wait a moment and try Add to cart again.';
            errEl.classList.remove('hidden');
          }
          resolve(false);
        }
      }, 40);
    });
  };

  function getCpcCalculator(form) {
    if (!form) return document.querySelector('#calculator');
    return form.querySelector('#calculator') || document.querySelector('#calculator');
  }

  function cpcField(calc, identifier) {
    return calc ? calc.querySelector('[data-identifier="' + identifier + '"]') : null;
  }

  function triggerCpcChange(el) {
    if (!el) return;
    if (el.tagName === 'SELECT' && typeof window.ChangeEvent === 'function') {
      window.ChangeEvent(null, el);
      return;
    }
    if (typeof window.PriceUpdation === 'function') {
      window.PriceUpdation(el);
    }
  }

  function selectCpcUnit(calc, unit, silent) {
    var sel = cpcField(calc, 'Measurement Units');
    if (!sel) return;
    var label = UNIT_TO_CPC_LABEL[unit] || unit;
    var options = Array.prototype.slice.call(sel.options);
    var match = options.find(function (opt) {
      var optLabel = (opt.dataset && opt.dataset.label) || opt.textContent.trim();
      return String(optLabel).toLowerCase() === String(label).toLowerCase();
    });
    if (match) {
      sel.value = match.value;
      if (!silent) triggerCpcChange(sel);
    }
  }

  function syncCpcNumberInput(calc, variantPriceCents, silent) {
    var numberInput = cpcField(calc, 'Number Input');
    if (!numberInput || variantPriceCents == null) return;
    var pounds = (variantPriceCents / 100).toFixed(2);
    numberInput.value = pounds;
    if (!silent) triggerCpcChange(numberInput);
  }

  function syncCpcTypePrice(calc, variantPriceCents, silent) {
    var typeEl = cpcField(calc, 'Type');
    if (!typeEl || variantPriceCents == null) return;
    var pounds = (variantPriceCents / 100).toFixed(2);
    typeEl.dataset.val = pounds;
    typeEl.setAttribute('data-val', pounds);
    Array.prototype.forEach.call(typeEl.options, function (opt) {
      opt.dataset.val = pounds;
      opt.setAttribute('data-val', pounds);
    });
    if (!silent) triggerCpcChange(typeEl);
  }

  function syncCpcVariantId(form, variant) {
    if (!form || !variant) return;
    var variantIdCustom = form.querySelector('#variantIdCustom');
    if (variantIdCustom) {
      variantIdCustom.value = String(variant.id);
    }
  }

  function getThemeQuantityInput(form) {
    if (window.cspGetThemeQuantityInput) return window.cspGetThemeQuantityInput(form);
    if (!form) return null;
    var formDomId = form.getAttribute('id');
    if (formDomId) {
      var byId = document.getElementById('quantity-' + formDomId);
      if (byId) return byId;
    }

    var named =
      form.elements && form.elements.namedItem ? form.elements.namedItem('quantity') : null;
    if (!named) return null;

    if (typeof named.length === 'number' && !named.tagName) {
      var i;
      for (i = 0; i < named.length; i++) {
        if (named[i].id && named[i].id.indexOf('quantity-') === 0) return named[i];
        if (named[i].closest && named[i].closest('quantity-input')) return named[i];
      }
      for (i = 0; i < named.length; i++) {
        if (!named[i].closest || !named[i].closest('#calculator')) return named[i];
      }
      return named[0] || null;
    }

    return named;
  }

  function neutralizeCpcQuantityFields(calc) {
    if (!calc) return;

    // CPC Quantity is not the Shopify cart quantity field — strip name so it cannot submit.
    var qtyEl = cpcField(calc, 'Quantity');
    if (qtyEl && qtyEl.getAttribute('name') === 'quantity') {
      qtyEl.removeAttribute('name');
    }

    var injectedQty = calc.querySelectorAll
      ? calc.querySelectorAll('input[name="quantity"], select[name="quantity"]')
      : [];
    Array.prototype.forEach.call(injectedQty, function (el) {
      el.removeAttribute('name');
    });
  }

  function syncToCpc(calc, form, values, options) {
    if (!calc) return false;
    options = options || {};
    var singleUpdate = !!options.singleUpdate;

    neutralizeCpcQuantityFields(calc);

    var widthEl = cpcField(calc, 'Width');
    var heightEl = cpcField(calc, 'Height');
    var qtyEl = cpcField(calc, 'Quantity');
    var billable = getBillableCpcDimensions(values.width, values.height, values.unit);
    var syncWidth = billable.width;
    var syncHeight = billable.height;

    if (widthEl && syncWidth != null) {
      widthEl.value = syncWidth;
      if (!singleUpdate) triggerCpcChange(widthEl);
    }
    if (heightEl && syncHeight != null) {
      heightEl.value = syncHeight;
      if (!singleUpdate) triggerCpcChange(heightEl);
    }
    if (values.unit) {
      selectCpcUnit(calc, values.unit, singleUpdate);
    }
    // CPC Quantity is not cart qty — keep it at 1 so price stays unit/area only.
    if (qtyEl) {
      if (String(qtyEl.value) !== '1') {
        qtyEl.value = '1';
        if (!singleUpdate) triggerCpcChange(qtyEl);
      }
      neutralizeCpcQuantityFields(calc);
    }
    if (values.variantPriceCents != null) {
      syncCpcNumberInput(calc, values.variantPriceCents, singleUpdate);
      syncCpcTypePrice(calc, values.variantPriceCents, singleUpdate);
    }
    if (values.variant) {
      syncCpcVariantId(form, values.variant);
    }

    if (singleUpdate) {
      var triggerEl = heightEl || widthEl || cpcField(calc, 'Number Input');
      triggerCpcChange(triggerEl);
    }

    return true;
  }

  function parseMoneyish(value) {
    if (value == null || value === '') return null;
    var cleaned = String(value).replace(/[^0-9.\-]/g, '');
    if (!cleaned) return null;
    var num = parseFloat(cleaned);
    return isNaN(num) ? null : num;
  }

  function readCpcResults(calc, form) {
    if (!calc) return null;

    var sqmInput = calc.querySelector('#calculation_inp_Total_Square_Meters');
    var priceInput = calc.querySelector('#calculation_inp_Calculated_price');
    var priceTicker = calc.querySelector('#priceTicker');
    var cpcToken = form ? form.querySelector('#cpcPriceToken') : null;

    var sqm = sqmInput ? parseFloat(sqmInput.value) : null;
    if (sqm != null && isNaN(sqm)) sqm = null;

    var totalMoney = null;
    if (priceTicker) {
      totalMoney =
        parseMoneyish(priceTicker.getAttribute('data-origmoney')) ||
        parseMoneyish(priceTicker.textContent);
    }
    if (totalMoney == null && priceInput) {
      totalMoney = parseMoneyish(priceInput.value);
    }

    var totalCents = totalMoney != null ? Math.round(totalMoney * 100) : null;
    var tokenReady = cpcToken && cpcToken.value && cpcToken.value !== 'none';

    return {
      sqm: sqm,
      totalCents: totalCents,
      tokenReady: tokenReady
    };
  }

  function waitForCpc(form, callback) {
    var attempts = 0;
    var timer = setInterval(function () {
      var calc = getCpcCalculator(form);
      if (calc && cpcField(calc, 'Width')) {
        clearInterval(timer);
        callback(calc);
      } else if (++attempts > 60) {
        clearInterval(timer);
        callback(null);
      }
    }, 100);
  }

  function initProductDimensionPricing(config) {
    var sectionId = config.sectionId;
    var root = document.querySelector('.product-dimension-fields[data-dimension-root="' + sectionId + '"]');
    if (!root) return;

    var formId = root.getAttribute('data-form-id');
    var form = document.getElementById(formId);
    var mainParentSel = root.getAttribute('data-main-parent');
    var priceRenderSel = root.getAttribute('data-price-render');
    var qtyRenderSel = root.getAttribute('data-qty-render');

    var inpW = root.querySelector('[data-dimension-width]');
    var inpH = root.querySelector('[data-dimension-height]');
    var selU = root.querySelector('[data-dimension-units]');
    var sqmDisplay = root.querySelector('[data-dimension-sqm-display]');
    var priceDisplay = root.querySelector('[data-dimension-price-display]');
    var errEl = root.querySelector('[data-dimension-error]');

    var cpcCalc = null;

    var state = {
      variantPriceCents: null,
      variantAvailable: true,
      variant: null,
      sqm: null,
      totalCents: null,
      unitPriceCents: null
    };

    function getMainParent() {
      return mainParentSel ? document.querySelector(mainParentSel) : document;
    }

    function getAtcButton() {
      if (!form) return null;
      return form.querySelector('[name="add"]');
    }

    function getDynamicCheckoutButtons() {
      if (!form) return [];
      var wrappers = form.querySelectorAll('.product-common_dynamic-btns, .shopify-payment-button');
      return Array.prototype.slice.call(wrappers);
    }

    function getQuantity() {
      var qtyInput = getThemeQuantityInput(form);
      var qty = parseInt(qtyInput && qtyInput.value ? qtyInput.value : '1', 10);
      var resolved = isNaN(qty) || qty < 1 ? 1 : qty;
      window.__cspDesiredCartQty = resolved;
      return resolved;
    }

    function showError(message) {
      if (!errEl) return;
      if (message) {
        errEl.textContent = message;
        errEl.classList.remove('hidden');
      } else {
        errEl.textContent = '';
        errEl.classList.add('hidden');
      }
    }

    function setSummaryPlaceholder() {
      if (sqmDisplay) {
        sqmDisplay.textContent = '—';
        sqmDisplay.classList.add('product-dimension-fields_summary-value--placeholder');
      }
      if (priceDisplay) {
        priceDisplay.textContent =
          state.variantPriceCents != null ? formatMoney(state.variantPriceCents) : '—';
        priceDisplay.classList.toggle(
          'product-dimension-fields_summary-value--placeholder',
          state.variantPriceCents == null
        );
      }
    }

    function updateSummary(sqm, unitPriceCents) {
      var sqmText = sqm != null ? sqm.toFixed(2) : '—';
      var priceText =
        unitPriceCents != null
          ? formatMoney(unitPriceCents)
          : state.variantPriceCents != null
            ? formatMoney(state.variantPriceCents)
            : '—';

      if (sqmDisplay) {
        sqmDisplay.textContent = sqmText;
        sqmDisplay.classList.toggle('product-dimension-fields_summary-value--placeholder', sqm == null);
      }
      if (priceDisplay) {
        priceDisplay.textContent = priceText;
        priceDisplay.classList.toggle(
          'product-dimension-fields_summary-value--placeholder',
          unitPriceCents == null && state.variantPriceCents == null
        );
      }
    }

    function updatePriceDisplay(unitPriceCents) {
      var parent = getMainParent();
      if (!parent || !priceRenderSel) return;
      var priceWrap = parent.querySelector(priceRenderSel);
      if (!priceWrap) return;

      var mainPrice = priceWrap.querySelector('.main-price');
      if (!mainPrice) return;

      // Before dimensions: keep showing the selected variant's per m² price
      // (not "Enter dimensions"). After dimensions: show calculated total.
      if (unitPriceCents == null) {
        if (state.variantPriceCents != null) {
          mainPrice.textContent = formatMoney(state.variantPriceCents);
        }
        return;
      }
      mainPrice.textContent = formatMoney(unitPriceCents);
    }

    function updateQuantitySubtotal(unitPriceCents) {
      var parent = getMainParent();
      if (!parent || !qtyRenderSel) return;
      var qtyWrap = parent.querySelector(qtyRenderSel);
      if (!qtyWrap) return;

      var quantityInput = qtyWrap.querySelector('quantity-input');
      var qtySubtotal = qtyWrap.querySelector('[data-qty-subtotal]');
      if (!quantityInput || !qtySubtotal) return;

      if (unitPriceCents == null) {
        quantityInput.dataset.variantPrice = '0';
        qtySubtotal.textContent = '—';
        return;
      }

      var qty = getQuantity();
      quantityInput.dataset.variantPrice = String(unitPriceCents);
      qtySubtotal.textContent = formatMoney(unitPriceCents * qty);
    }

    function setAtcEnabled(valid) {
      var atcBtn = getAtcButton();
      var canPurchase = valid && state.variantAvailable;

      if (atcBtn) {
        if (canPurchase) {
          atcBtn.removeAttribute('disabled');
          var textContainer = atcBtn.querySelector('[data-atc-text]');
          if (textContainer && textContainer.dataset.textAvail) {
            textContainer.innerText = textContainer.dataset.textAvail;
          }
        } else if (!state.variantAvailable) {
          atcBtn.setAttribute('disabled', '');
        } else {
          atcBtn.setAttribute('disabled', '');
        }
      }

      getDynamicCheckoutButtons().forEach(function (el) {
        if (canPurchase) {
          el.classList.remove('hidden');
          el.removeAttribute('aria-hidden');
        } else {
          el.classList.add('hidden');
          el.setAttribute('aria-hidden', 'true');
        }
      });
    }

    function recalculateWithFallback(wn, hn, unit, qty) {
      var sqm = calculateSquareMeters(wn, hn, unit);
      var unitPriceCents = calculateTotalPrice(sqm, state.variantPriceCents);
      var totalCents = unitPriceCents != null ? unitPriceCents * qty : null;

      state.sqm = sqm;
      state.unitPriceCents = unitPriceCents;
      state.totalCents = totalCents;

      updateSummary(sqm, unitPriceCents);
      updatePriceDisplay(unitPriceCents);
      updateQuantitySubtotal(unitPriceCents);
      setAtcEnabled(true);
      showError('');
    }

    function recalculate() {
      var w = (inpW && inpW.value.trim()) || '';
      var h = (inpH && inpH.value.trim()) || '';
      var unit = (selU && selU.value) || '';
      var validation = validateDimensions(w, h, unit);

      if (!validation.valid) {
        state.unitPriceCents = null;
        state.totalCents = null;
        state.sqm = null;
        setAtcEnabled(false);
        updatePriceDisplay(null);
        updateQuantitySubtotal(null);
        setSummaryPlaceholder();
        showError('');
        return validation;
      }

      var wn = validation.width;
      var hn = validation.height;
      var qty = getQuantity();
      rememberValidDimensions({
        width: wn,
        height: hn,
        unit: unit,
        sqm: validation.sqm
      });

      if (cpcCalc) {
        syncToCpc(cpcCalc, form, {
          width: wn,
          height: hn,
          unit: unit,
          quantity: qty,
          variantPriceCents: state.variantPriceCents,
          variant: state.variant
        });

        var cpcResults = readCpcResults(cpcCalc, form);
        // CPC returns the area/unit price (not qty-inclusive).
        // Display the customer's real area; CPC was synced with billable (>= 1 m²) dims.
        if (cpcResults && cpcResults.totalCents != null && cpcResults.totalCents > 0) {
          var unitPriceCents = cpcResults.totalCents;
          if (
            validation.sqm != null &&
            validation.sqm < MIN_AREA_SQM &&
            state.variantPriceCents != null
          ) {
            unitPriceCents = Math.round(MIN_AREA_SQM * state.variantPriceCents);
          }
          state.sqm = validation.sqm;
          state.unitPriceCents = unitPriceCents;
          state.totalCents = unitPriceCents * qty;

          updateSummary(validation.sqm, unitPriceCents);
          updatePriceDisplay(unitPriceCents);
          updateQuantitySubtotal(unitPriceCents);
          setAtcEnabled(true);
          showError('');
          return validation;
        }
      }

      recalculateWithFallback(wn, hn, unit, qty);
      return validation;
    }

    function onVariantChange(variant) {
      if (!variant) return;
      state.variant = variant;
      state.variantPriceCents = variant.price;
      state.variantAvailable = variant.available !== false;
      if (typeof window.cspUpdatePerSqmPrice === 'function') {
        window.cspUpdatePerSqmPrice(variant, sectionId);
      }
      if (cpcCalc) {
        syncCpcNumberInput(cpcCalc, variant.price);
        syncCpcTypePrice(cpcCalc, variant.price);
        syncCpcVariantId(form, variant);
      }
      recalculate();
    }

    document.addEventListener('cascade:variant-change', function (e) {
      if (e.detail && String(e.detail.sectionId) === String(sectionId)) {
        onVariantChange(e.detail.variant);
      }
    });

    window.themeAfterVariantRender = function (renderSectionId) {
      if (String(renderSectionId) !== String(sectionId)) return;
      recalculate();
    };

    function sanitizeDecimalField(el) {
      if (!el) return;
      var raw = String(el.value || '');
      var cleaned = raw.replace(/[^\d.]/g, '');
      var dot = cleaned.indexOf('.');
      if (dot !== -1) {
        cleaned = cleaned.slice(0, dot + 1) + cleaned.slice(dot + 1).replace(/\./g, '');
      }
      if (cleaned === raw) return;

      var start = el.selectionStart || 0;
      var prefix = raw.slice(0, start).replace(/[^\d.]/g, '');
      var prefixDot = prefix.indexOf('.');
      if (prefixDot !== -1) {
        prefix = prefix.slice(0, prefixDot + 1) + prefix.slice(prefixDot + 1).replace(/\./g, '');
      }
      el.value = cleaned;
      try {
        el.setSelectionRange(prefix.length, prefix.length);
      } catch (e) { /* ignore */ }
    }

    [inpW, inpH].forEach(function (el) {
      if (!el) return;
      el.addEventListener('beforeinput', function (e) {
        if (e.inputType && e.inputType.indexOf('insert') === 0 && typeof e.data === 'string') {
          if (e.data !== '' && !/^[0-9.]+$/.test(e.data)) {
            e.preventDefault();
          }
        }
      });
      el.addEventListener('keypress', function (e) {
        if (e.ctrlKey || e.metaKey || e.altKey || !e.key || e.key.length !== 1) return;
        if (!/[0-9.]/.test(e.key)) e.preventDefault();
      });
      el.addEventListener('paste', function (e) {
        var text = '';
        try {
          text = (e.clipboardData || window.clipboardData).getData('text') || '';
        } catch (err) {
          return;
        }
        if (!text) return;
        e.preventDefault();
        var start = el.selectionStart || 0;
        var end = el.selectionEnd || 0;
        var next = String(el.value || '').slice(0, start) + text + String(el.value || '').slice(end);
        var cleaned = next.replace(/[^\d.]/g, '');
        var cleanedDot = cleaned.indexOf('.');
        if (cleanedDot !== -1) {
          cleaned = cleaned.slice(0, cleanedDot + 1) + cleaned.slice(cleanedDot + 1).replace(/\./g, '');
        }
        el.value = cleaned;
        try {
          el.setSelectionRange(cleaned.length, cleaned.length);
        } catch (err2) { /* ignore */ }
        el.dispatchEvent(new Event('input', { bubbles: true }));
      });
      el.addEventListener('input', function () {
        sanitizeDecimalField(el);
        recalculate();
      });
      el.addEventListener('change', function () {
        sanitizeDecimalField(el);
        recalculate();
      });
    });

    if (selU) {
      selU.addEventListener('input', function () {
        recalculate();
      });
      selU.addEventListener('change', function () {
        recalculate();
      });
    }

    if (form) {
      form.addEventListener(
        'submit',
        function (e) {
          var prepared = prepareDimensionsForCart(form);
          if (!prepared.ok) {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          // Do not call syncToCpc/PriceUpdation on submit — it invalidates CPC's add token.
        },
        true
      );

      var qtyInput = getThemeQuantityInput(form);
      if (qtyInput) {
        qtyInput.addEventListener('change', function () {
          recalculate();
        });
        qtyInput.addEventListener('input', function () {
          recalculate();
        });
      }
    }

    setSummaryPlaceholder();
    updatePriceDisplay(null);
    updateQuantitySubtotal(null);
    setAtcEnabled(false);

    waitForCpc(form, function (calc) {
      cpcCalc = calc;
      if (!cpcCalc) return;

      neutralizeCpcQuantityFields(cpcCalc);

      if (state.variant) {
        syncCpcNumberInput(cpcCalc, state.variantPriceCents);
        syncCpcTypePrice(cpcCalc, state.variantPriceCents);
        syncCpcVariantId(form, state.variant);
      }

      recalculate();
    });

    var variantIdInput = form ? form.querySelector('input[name="id"]') : null;
    if (variantIdInput) {
      var fullJsonEl = document.getElementById('CustomVariantsFull-' + sectionId);
      if (fullJsonEl) {
        try {
          var variants = JSON.parse(fullJsonEl.textContent);
          var currentId = parseInt(variantIdInput.value, 10);
          var current = variants.find(function (v) {
            return v.id === currentId;
          });
          if (current) onVariantChange(current);
        } catch (e) {
          /* ignore */
        }
      }
    }
  }

  window.initProductDimensionPricing = initProductDimensionPricing;
  window.productDimensionPricing = {
    convertToMeters: convertToMeters,
    calculateSquareMeters: calculateSquareMeters,
    calculateTotalPrice: calculateTotalPrice,
    validateDimensions: validateDimensions,
    prepareDimensionsForCart: prepareDimensionsForCart
  };
})();
